import { traverse } from '../traverse/traverse';
import { extension } from '../builders';
const NESTED_TABLE_EXTENSION_TYPE = 'com.atlassian.nesting',
  NESTED_TABLE_EXTENSION_KEY = 'nested-table';
const isNestedTableExtension = extensionNode => {
  var _extensionNode$attrs, _extensionNode$attrs2;
  return ((_extensionNode$attrs = extensionNode.attrs) === null || _extensionNode$attrs === void 0 ? void 0 : _extensionNode$attrs.extensionType) === NESTED_TABLE_EXTENSION_TYPE && ((_extensionNode$attrs2 = extensionNode.attrs) === null || _extensionNode$attrs2 === void 0 ? void 0 : _extensionNode$attrs2.extensionKey) === NESTED_TABLE_EXTENSION_KEY;
};
const transformNestedTableExtension = nestedTableExtension => {
  var _nestedTableExtension, _nestedTableExtension2, _nestedTableExtension3;
  // No content - drop the extension node
  if (!((_nestedTableExtension = nestedTableExtension.attrs) !== null && _nestedTableExtension !== void 0 && (_nestedTableExtension2 = _nestedTableExtension.parameters) !== null && _nestedTableExtension2 !== void 0 && (_nestedTableExtension3 = _nestedTableExtension2.macroParams) !== null && _nestedTableExtension3 !== void 0 && _nestedTableExtension3.nestedContent)) {
    return false;
  }
  try {
    var _nestedTableExtension4, _nestedTableExtension5, _nestedTableExtension6;
    return JSON.parse((_nestedTableExtension4 = nestedTableExtension.attrs) === null || _nestedTableExtension4 === void 0 ? void 0 : (_nestedTableExtension5 = _nestedTableExtension4.parameters) === null || _nestedTableExtension5 === void 0 ? void 0 : (_nestedTableExtension6 = _nestedTableExtension5.macroParams) === null || _nestedTableExtension6 === void 0 ? void 0 : _nestedTableExtension6.nestedContent.value);
  } catch (e) {
    throw new Error('Failed to parse nested table content');
  }
};
export const transformNestedTablesIncomingDocument = adf => {
  let isTransformed = false;
  const transformedAdf = traverse(adf, {
    extension: node => {
      if (isNestedTableExtension(node)) {
        isTransformed = true;
        return transformNestedTableExtension(node);
      }
    }
  });
  return {
    transformedAdf,
    isTransformed
  };
};
export const transformNestedTableNodeOutgoingDocument = tableCellNode => {
  var _tableCellNode$conten;
  return {
    ...tableCellNode,
    content: (_tableCellNode$conten = tableCellNode.content) === null || _tableCellNode$conten === void 0 ? void 0 : _tableCellNode$conten.map(childNode => {
      // wrap nested table in an extension node
      if ((childNode === null || childNode === void 0 ? void 0 : childNode.type) === 'table') {
        return extension({
          extensionType: NESTED_TABLE_EXTENSION_TYPE,
          extensionKey: NESTED_TABLE_EXTENSION_KEY,
          parameters: {
            macroParams: {
              nestedContent: {
                value: JSON.stringify(childNode)
              }
            }
          }
        });
      }
      return childNode;
    })
  };
};